import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Admin = Loadable({
  loader: () => import("./components/admin"),
  loading: Loading,
});

const AddConnection = Loadable({
  loader: () => import("./components/add-connection"),
  loading: Loading,
});

const AddConnectionHeader = Loadable({
  loader: () => import("./components/add-connection-header"),
  loading: Loading,
});

const AddNotice = Loadable({
  loader: () => import("./components/add-notice"),
  loading: Loading,
});

const EmailLogs = Loadable({
  loader: () => import("./components/email-logs"),
  loading: Loading,
});

const WebLogs = Loadable({
  loader: () => import("./components/web-logs"),
  loading: Loading,
});

const SendEmails = Loadable({
  loader: () => import("./components/send-emails"),
  loading: Loading,
});

const SendWeelyEmails = Loadable({
  loader: () => import("./components/send-weekly-emails"),
  loading: Loading,
});
const AddPlace = Loadable({
  loader: () => import("./components/add-place"),
  loading: Loading,
});

const AddPage = Loadable({
  loader: () => import("./components/add-page"),
  loading: Loading,
});

const ReadPosts = Loadable({
  loader: () => import("./components/read-posts"),
  loading: Loading,
});

export const routes = [
  {
    path: "/admin",
    exact: true,
    name: "Admin",
    component: Admin,
    // "permission": {
    //   "contactype": [
    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/add-place",
    exact: true,
    name: "Add place",
    component: AddPlace,
  },
  {
    path: "/admin/edit-place/:id",
    exact: true,
    name: "Edit place",
    component: AddPlace,
  },
  {
    path: "/admin/add-page",
    exact: true,
    name: "Add page",
    component: AddPage,
  },
  {
    path: "/admin/edit-page/:id",
    exact: true,
    name: "Edit page",
    component: AddPage,
  },

  {
    path: "/admin/add-newsletter",
    exact: true,
    name: "Add newsletter",
    component: AddConnection,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/edit-newsletter/:id",
    exact: true,
    name: "Edit newsletter",
    component: AddConnection,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/add-notice",
    exact: true,
    name: "Add notice",
    component: AddNotice,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/edit-notice/:id",
    exact: true,
    name: "Edit notice",
    component: AddNotice,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/add-newsletter-header",
    exact: true,
    name: "Add newsletter header",
    component: AddConnectionHeader,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // },
  },
  {
    path: "/admin/email-logs",
    exact: true,
    name: "Email Logs",
    component: EmailLogs,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // }
  },
  {
    path: "/admin/email-logs/send-principal-emails",
    exact: true,
    name: "Send Princiapl Emails",
    component: SendEmails,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // }
  },
  {
    path: "/admin/email-logs/send-weekly-emails",
    exact: true,
    name: "Send Weekly Emails",
    component: SendWeelyEmails,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile"
    //   ]
    // }
  },
  {
    path: "/admin/web-logs/",
    exact: true,
    name: "Web Logs",
    component: WebLogs,
  },
  {
    path: "/admin/read-posts/",
    exact: true,
    name: "Read Posts",
    component: ReadPosts
  }
];

export * from "./components";

// export * from './adminActions';
// export * from './adminReducer';
